/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarveOutTrackingListEntryPayer
 */
export interface CarveOutTrackingListEntryPayer {
    /**
     * 
     * @type {string}
     * @memberof CarveOutTrackingListEntryPayer
     */
    name?: string;
}

/**
 * Check if a given object implements the CarveOutTrackingListEntryPayer interface.
 */
export function instanceOfCarveOutTrackingListEntryPayer(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CarveOutTrackingListEntryPayerFromJSON(json: any): CarveOutTrackingListEntryPayer {
    return CarveOutTrackingListEntryPayerFromJSONTyped(json, false);
}

export function CarveOutTrackingListEntryPayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutTrackingListEntryPayer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CarveOutTrackingListEntryPayerToJSON(value?: CarveOutTrackingListEntryPayer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

